// extracted by mini-css-extract-plugin
export default {"main":"styles_main__iYy9M","image":"styles_image__G9fq7","text":"styles_text__xiMrx","button":"styles_button__VnUKV"};